import { clampMarkSize, type FernieFaceState } from "~/components/fernie/fernieMarkRules";
import { fernieColors } from "~/themes/fernieBrand";

export type FernieSproutPulse = "none" | "soft" | "hard";

export interface FernieFaceAnimation {
	ledColor: string;
	glow: boolean;
	blink: boolean;
	eyeScan: boolean;
	sproutPulse: FernieSproutPulse;
	grin: boolean;
}

export const GRIN_DURATION_MS = 1400;

const STILL: Omit<FernieFaceAnimation, "ledColor" | "glow"> = {
	blink: false,
	eyeScan: false,
	sproutPulse: "none",
	grin: false
};

export function resolveFaceAnimation(state: FernieFaceState, reducedMotion: boolean): FernieFaceAnimation {
	if (state === "straight") {
		return { ledColor: fernieColors.dim, glow: false, ...STILL };
	}

	const lit = { ledColor: fernieColors.led, glow: true };

	if (reducedMotion) {
		return { ...lit, ...STILL };
	}

	switch (state) {
		case "rest":
			return { ...lit, ...STILL, blink: true };
		case "listening":
			return { ...lit, ...STILL };
		case "thinking":
			return { ...lit, ...STILL, eyeScan: true, sproutPulse: "soft" };
		case "working":
			return { ...lit, ...STILL, sproutPulse: "hard" };
		case "done":
			return { ...lit, ...STILL, grin: true };
	}
}

export interface FaceMachineState {
	requested: FernieFaceState;
	displayed: FernieFaceState;
}

export type FaceMachineEvent = { type: "request"; state: FernieFaceState } | { type: "grinComplete" };

export function initFaceMachine(state: FernieFaceState): FaceMachineState {
	return { requested: state, displayed: state };
}

export function faceMachineReducer(machine: FaceMachineState, event: FaceMachineEvent): FaceMachineState {
	switch (event.type) {
		case "request":
			return { requested: event.state, displayed: event.state };
		case "grinComplete":
			return machine.displayed === "done" ? { requested: machine.requested, displayed: "rest" } : machine;
	}
}

export function resolveAnimatedFaceWidth(size: number): number {
	return clampMarkSize("face", size);
}
